import { ComingSoon } from '../shared/ComingSoon';

// The owner's console: inviting loan officers and turning accounts off. It never shows clients.
export function OwnerHome() {
  return (
    <ComingSoon title="Owner console">
      Coming after loan-officer sign-in.
    </ComingSoon>
  );
}
